/* eslint-disable @typescript-eslint/no-unused-vars */
import { IStudyInformation } from '@/interfaces/study-information.interface';
import { StudyClient } from '@/infrastructure/study-client';
import { MiniProgrammeCard } from "@studyportals/domain-client";

export class StudyRepository {
	private studyClient: StudyClient;

	private requestCache = new Map<number, Promise<IStudyInformation>>();
	private defaultData: IStudyInformation = {
		studyTitle: "Couldn't find Study",
		universityTitle: "Couldn't find University",
		referralLink: null,
		isPremium: false,
		organizationId: null
	};

	constructor() {
		this.studyClient = new StudyClient();
	}

	public async get(studyId: number): Promise<IStudyInformation> {
		if (!this.requestCache.has(studyId)) {
			this.requestCache.set(studyId, this.retrieveStudyInformation(studyId));
		}

		return this.requestCache.get(studyId)!;
	}

	private async retrieveStudyInformation(studyId: number): Promise<IStudyInformation> {
		try {
			const result = await this.studyClient.getMiniCard(studyId);
			return this.parseData(result);
		} catch (error) {
			console.error(error);
			return this.defaultData;
		}
	}

	private parseData(card: MiniProgrammeCard): IStudyInformation {
		return {
			studyTitle: card.title,
			universityTitle: card.universityLink?.description || '',
			referralLink: card.referralLink || null,
			isPremium: card.isPremium,
			organizationId: card.universityId
		};
	}
}
